module.exports = __webpack_public_path__ + "static/media/miniPdf.f1f4d73a.svg";